import { render, staticRenderFns } from "./calc-header.vue?vue&type=template&id=524fa9ae&scoped=true"
import script from "./calc-header.vue?vue&type=script&lang=ts"
export * from "./calc-header.vue?vue&type=script&lang=ts"
import style0 from "./calc-header.vue?vue&type=style&index=0&id=524fa9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524fa9ae",
  null
  
)

export default component.exports